import { render, staticRenderFns } from "./artist.vue?vue&type=template&id=e27cb834"
import script from "./artist.vue?vue&type=script&lang=js"
export * from "./artist.vue?vue&type=script&lang=js"
import style0 from "./artist.vue?vue&type=style&index=0&id=e27cb834&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports